//a module to check if the React App/React Bundle is running in the App.


const createValidRelativeUrl = (urlString) => {
  try {
    return new URL(urlString).pathname;
  }
  catch(e){
    return false;
  }
}

export default createValidRelativeUrl


